<template>
<div class="feature-box">
    <a href="##" @click.prevent="func">
        <div class="heading">
            Create
        </div>
        <div class="content">
            <i class="plus-large"></i>
        </div>
    </a>
</div>
</template>

<script>

export default {
    props: ['func']
}
</script>